import './App.css';
import LandingScreen from './components/LandingScreen';
import SkillsScreen from './components/SkillsScreen';
import ProjectsScreen from './components/ProjectsScreen';
import ContactMeScreen from './components/ContactMeScreen';

function App() {
  return (
    <>
      <div className='ScrollApp'>
        <div className='AppContent'>
          <div className='w-screen h-screen z-10 bg-black top-0 '>
            <LandingScreen />
          </div>
          <div className='w-screen h-screen z-20 top-0 '>
            <SkillsScreen />
          </div>
          <div className='w-screen h-auto z-30 top-0 '>
            <ProjectsScreen />
          </div>
          <div className='w-screen h-screen z-40 top-0'>
            <ContactMeScreen />
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
